import * as React from 'react';

import { css } from '@emotion/react';
import { ProgressBar } from '@opendoor/bricks/complex';
import { Box, Flex, Text } from '@opendoor/bricks/core';
import Footer from '@opendoor/bricks/deprecated/UNSAFE_layout/Footer';
import { useTheme } from '@opendoor/bricks/system/theme';

interface ILayoutProps {
  children: React.ReactNode;
  currentSlug?: string;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  progressPercentage: number;
  renderBackButton: () => any;
  bannerText?: string;
  carrotText?: string;
  hideFooter?: boolean;
  hideProgressBar?: boolean;
  renderNavigationControl?: () => any;
}

const Layout: React.FC<ILayoutProps> = ({
  currentSlug,
  bannerText,
  carrotText,
  hideFooter,
  hideProgressBar,
  onSubmit,
  progressPercentage,
  renderBackButton,
  children,
  renderNavigationControl,
}) => {
  const { colors } = useTheme();
  const isPreviewPage = currentSlug === 'preview';

  return (
    <Flex
      css={css`
        /* for safari 15.4 */
        min-height: calc(100vh - 52px);
        /* for everyone else  */
        min-height: calc(100dvh - 52px);
      `}
      flexDirection="column"
    >
      <Box data-testid="progress-bar">
        {!hideProgressBar && (
          <ProgressBar
            progress={progressPercentage}
            carrotText={carrotText}
            carrotPositionDesktop="below"
            dockPositionMobile="above"
            gradientProgress={false}
            colorStart={colors.brand50 as string}
          />
        )}
      </Box>
      {bannerText && (
        <Box py={5} backgroundColor="neutrals20">
          <Text
            textAlign="center"
            fontSize={['s1', 's2']}
            fontWeight="semibold"
            color="neutrals100"
          >
            {bannerText}
          </Text>
        </Box>
      )}
      <Flex flexGrow={1} flexDirection={['column', 'row']}>
        <Box position="absolute" display={['none', 'block']} px={10} pt={10}>
          <Text as="div" fontSize="s1" fontWeight="bold">
            {renderBackButton()}
          </Text>
        </Box>
        <Flex
          maxWidth="800px"
          width="100%"
          margin="0 auto"
          flexGrow={1}
          flexDirection="column"
          justifyContent="space-between"
          px={[7, 10]}
        >
          {/* Navigation Buttons i.e. Get Started on custom "questions" */}
          <form method="post" onSubmit={onSubmit}>
            <Flex flexDirection="column" alignItems="center">
              <Box width="100%">{children}</Box>
              {renderNavigationControl && renderNavigationControl()}
            </Flex>
          </form>
          <Box data-testid="reception-footer" marginBottom={['110px', 0]}>
            {!hideFooter && <Footer />}
            {isPreviewPage && (
              <Text fontSize="s00" lineHeight="s000" mb={4} textAlign="center">
                An Opendoor home value estimate is not an appraisal.
              </Text>
            )}
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};
export default Layout;
